const ACTION_TYPES = {};

const initialState = {
    rewards: null,
    rewardsPurchasedGroups: null,
    rewardsPurchasedGroupsError: false,
    rewardsPurchasedGroupsLoading: false
};

const reducer = function (state = initialState) {
    return state;
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
